import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { sanitizePostHtml, sanitizePostText } from 'services/sanitizationService';
import PostContext from './PostContext';
import PostWrapper from './PostWrapper';
import PostHeader from './PostHeader';
import PostBody from './PostBody';
import PostMedia from './PostMedia';

// Presentational only: a post another workspace shared is not in the store.
const PostCard = ({ context, postId, preheader, header, beforeBody, body, bodyHtml, bodyProps, extras, media, children, ...rest }) => {
  const html = useMemo(
    () => (bodyHtml ? sanitizePostHtml(bodyHtml) : sanitizePostText(body)),
    [body, bodyHtml],
  );

  return (
    <PostContext.Provider value={context}>
      {/* Without a postId, PostWrapper skips its read tracking — which is what a
          card for another workspace's post needs. */}
      <PostWrapper postId={postId} {...rest}>
        {preheader}
        {header && <PostHeader {...header} />}
        {beforeBody}
        <PostBody {...bodyProps} html={html} />
        {extras}
        {media?.length > 0 && <PostMedia media={media} />}
        {children}
      </PostWrapper>
    </PostContext.Provider>
  );
};

PostCard.propTypes = {
  context: PropTypes.object.isRequired,
  postId: PropTypes.any, // Omit to render a post the store does not own
  preheader: PropTypes.node,
  header: PropTypes.object, // PostHeader props, or null to hide the header
  beforeBody: PropTypes.node,
  body: PropTypes.string,
  bodyHtml: PropTypes.string,
  bodyProps: PropTypes.object,
  extras: PropTypes.node,
  media: PropTypes.array,
};

export default PostCard;
